import { render, staticRenderFns } from "./AuthForgotPassword.vue?vue&type=template&id=7ff60c4b&scoped=true&"
import script from "./AuthForgotPassword.vue?vue&type=script&lang=js&"
export * from "./AuthForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./AuthForgotPassword.vue?vue&type=style&index=0&id=7ff60c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff60c4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VTextField})
